import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-copy-text',
  templateUrl: './copy-text.component.html',
  styleUrls: ['./copy-text.component.less'],
})
export class CopyTextComponent implements OnInit {
  @Input() textToDisplay: string;
  @Input() textToCopy: string;
  @Input() customCopyTooltipText: string;
  @Input() nzColor = 'default';
  @Input() nzTheme: 'outline' | 'fill' = 'outline';
  @Input() textPosition: 'left' | 'right' = 'left';
  @Input() size: 'large' | 'default' | 'small' | 'smaller' = 'small';
  @Input() variant: 'button' | 'icon' = 'icon';
  @Input() customClass: string;
  @Input() hoverClassName: string;
  hovered: boolean;

  constructor() {}

  ngOnInit(): void {}
}
